import classNames from 'classnames';
import { FC, memo } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { SwiperOptions } from 'swiper/types';

export interface NewCarouselProps extends SwiperOptions {
  className?: string;
  classNameForSlide?: string;
  slides?: JSX.Element[];
}

const _NewCarousel: FC<NewCarouselProps> = ({ className, classNameForSlide, slides, ...rest }) => {
  return (
    <Swiper className={classNames(className)} {...rest}>
      {slides?.map((slide, index) => (
        <SwiperSlide className={classNames(classNameForSlide)} key={index}>
          {slide}
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export const NewCarousel = memo(_NewCarousel);
